// extracted by css-extract-rspack-plugin
export default {"updateBtn":"ObjectProtectionButton_updateBtn__btquG"};